import { useMutation } from "@tanstack/react-query"
import { Form, Input } from "antd"
import { Button } from "components"
import { mixPanelEvent } from "components/new-stuff/mix-panel/MixPanel"
import NewModalWrapper from "components/new-stuff/ui/modals/NewModalWrapper"
import React, { useState } from "react"
import { paymentSchedulesService } from "services/paymentSchedulesService"
import { useAppNotificationStore } from "stores"
import getIdFromKey from "utils/getIdFromKey"
import { onQueryError } from "utils/utils"
type Props = {
  onClose: () => void
  invalidateQueries: () => void
  open: boolean
  paymentId: string
  x: string
  currency?: string
}

export const ResetPayment = ({
  onClose,
  open,
  paymentId,
  currency,
  x,
  invalidateQueries,
}: Props) => {
  const { toast } = useAppNotificationStore()
  const [comment, setComment] = useState("")
  const { isLoading: isSubmittingResetSingle, mutate: submitResetSingle } =
    useMutation({
      mutationFn: async (body: string) => {
        const data = await paymentSchedulesService.resetItem(
          paymentId,
          body,
          currency
        )
        return data
      },
      onSuccess: (data) => {
        onClose()
        setComment("")
        invalidateQueries()
        data?.message && toast.success(data.message)
        mixPanelEvent("pay-schedule-payout-reset-success")
      },
      onError: (data: any) => {
        onClose()
        setComment("")
        onQueryError(data)
      },
    })

  const { isLoading: isSubmittingResetAll, mutate: submitResetAll } =
    useMutation({
      mutationFn: async (body: string) => {
        const data = await paymentSchedulesService.resetItems(
          paymentId,
          body,
          currency
        )
        return data
      },
      onSuccess: (data) => {
        onClose()
        setComment("")
        invalidateQueries()
        data?.message && toast.success(data.message)
        mixPanelEvent("pay-schedule-payout-reset-success")
      },
      onError: (e) => {
        onClose()
        setComment("")
        onQueryError(e)
      },
    })
  return (
    <NewModalWrapper
      open={open}
      title={
        paymentId == getIdFromKey(x || "")
          ? "Reset Cheque Payments"
          : "Reset Cheque Payment"
      }
      className="w-[750px]"
      onClose={onClose}
    >
      <div className="px-5 py-3">
        <p className=" text-neutral300 mb-5 text-sm">
          {paymentId == getIdFromKey(x || "")
            ? `All successful cheque payments will be reset to unprocessed
                state. Provide reason to continue.`
            : `This payment will be reset to unprocessed state. Provide reason to continue.`}
        </p>
        <Form.Item
          name="reason"
          rules={[
            {
              required: true,
              message: "Please input your reason!",
            },
          ]}
        >
          <Input
            className="h-10 mb-5"
            placeholder="Reason"
            onChange={(e) => setComment(e.target.value)}
          />
        </Form.Item>
      </div>
      <div className="border py-5 px-6 flex gap-4 justify-end ">
        <Button
          color="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          color="primary"
          // onClick={onFinish}
          submitting={isSubmittingResetAll || isSubmittingResetSingle}
          disabled={comment == "" ? true : false}
          onClick={() => {
            mixPanelEvent("pay-schedule-payout-reset-init")
            {
              paymentId == getIdFromKey(x || "")
                ? submitResetAll(comment)
                : submitResetSingle(comment)
            }
          }}
        >
          Reset
        </Button>
      </div>
    </NewModalWrapper>
  )
}

export default ResetPayment
